import PropTypes from 'prop-types';
import {Checkbox, Grid, Segment} from 'semantic-ui-react';
import ExpandCollapseToggleButton from './ExpandCollapseToggleButton';
import ComparableColumns from './ComparableColumns';
import Typography from '@mui/material/Typography';

ComparableColumnsHeader.propTypes = {
  records: PropTypes.number.isRequired,
  comparablesType: PropTypes.string.isRequired,
  fetching: PropTypes.bool.isRequired,
  pagination: PropTypes.object.isRequired,
  selectAll: PropTypes.bool.isRequired,
  selectedCount: PropTypes.number.isRequired,
  onExpandCollapseAll: PropTypes.func.isRequired,
  onUpdateSelectAll: PropTypes.func.isRequired,
};

const noWrap = {whiteSpace: 'nowrap'};

export default function ComparableColumnsHeader({
  records,
  fetching,
  selectAll,
  selectedCount,
  comparablesType,
  pagination,
  onUpdateSelectAll,
  onExpandCollapseAll,
}) {
  let page = pagination.page;
  let size = pagination.size;
  let totalElements = pagination.totalElements;
  let propertyCountDiff;

  if (totalElements <= (size * (page + 1))) {
    propertyCountDiff = totalElements - records;
  } else {
    propertyCountDiff = size * (page + 1) - records;
  }

  let totalCountOfElements = totalElements;
  if (propertyCountDiff) {
    totalCountOfElements -= propertyCountDiff;
  }
  const recordsText = ` (${records} of ${totalCountOfElements} shown)`;
  const recordsStatusText = fetching || (pagination.totalElements === 0)
      ? undefined
      : <Typography variant="fontWeight600">{recordsText}</Typography>;
  const selectedStatusText = `${selectedCount} selected`;

  return (
    <Segment className="comparable-columns-header">
      <ComparableColumns
        onSelectClick={() => onUpdateSelectAll({}, {checked: !selectAll})}
        column1={<Checkbox checked={selectAll}/>}
        column2={<span className="selected-comparables"
                       style={{verticalAlign: 'top'}}>{selectedStatusText}{recordsStatusText}</span>}
        column3={<h4>Land</h4>}
        column4={<h4 style={noWrap}>{comparablesType} Price</h4>}
        column5={<h4 style={noWrap}>{comparablesType} Date</h4>}
        column6={<h4>DOM</h4>}
        column7={
          <Grid columns={1}>
            <Grid.Row>
              <Grid.Column textAlign="right">
                <ExpandCollapseToggleButton onChange={onExpandCollapseAll}/>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        }
      />
    </Segment>
  );
}